import { Fragment, useState, useEffect } from 'react';
import RenderInfoLogic from '../../../../../components/InfoSidebar/RenderInfoLogic';
import SharedButton from '../../../../../global/Button/Button';
import { getAvailableCharts } from '../../helpers/graphHelpers.ts';
import { useRightSidebarLayout } from '../../context/RightSidebarLayoutContext';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/16/solid';

interface ManageGraphsProps {
  sectionTitle: any;
  tab: any;
  view: any;
  source: any;
  names: any;
  searchItems: any;
  title: any;
  Graph?: any;
  setSearchItems: any;
}

function ManageGraphs({
  sectionTitle,
  tab,
  view,
  source,
  names, // Rename to searchItems
  searchItems,
  title, // Better title? ala sectionTitle
  Graph = null, // Not passed, refactor away
  setSearchItems,
}: ManageGraphsProps) {
  const { isSidebarOpen, setSidebarOpen } = useRightSidebarLayout();
  const [chartsSelect, setChartsSelect] = useState(false);

  const handleDropdownClick = (item: string) => {
    setSelectedChart(item.toUpperCase());
    setChartsSelect(!chartsSelect);
  };

  let keySearch = '';

  if (searchItems.length > 0) {
    let prefix = '';
    if (title === 'DISEASES') {
      prefix = 'disease=';
      keySearch = `${prefix}${searchItems.map((item: any) => `UMLS_${item.id}`).join(',')}`;
    } else if (title === 'GENES') {
      prefix = 'gene_ncbi_id=';
      keySearch = `${prefix}${searchItems.map((item: any) => item.id).join(',')}`;
    } else if (title === 'VARIANTS') {
      prefix = 'variant=';
      keySearch = `${prefix}${searchItems.map((item: any) => item.id).join(',')}`;
    }
  }

  const defaultChart =
    searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES')
      ? 'HEATMAP'
      : 'LINE';
  const [selectedChart, setSelectedChart] = useState(defaultChart);

  // useEffect(() => {
  //   if (!(searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES'))) {
  //     setSelectedChart('LINE');
  //   }
  // }, [searchItems]);

  useEffect(() => {
    if (searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES')) {
      setSelectedChart('HEATMAP');
    } else {
      setSelectedChart('LINE');
    }
  }, [searchItems, names, title]);

  return (
    <Fragment>
      <div className="Cabtabla mt-3">
        {names && (
          <div className="row items-end justify-start md:justify-end mb-4 md:mb-0">
            <RenderInfoLogic
              searchItems={searchItems}
              selectedInfoItem={null}
              setSearchItems={setSearchItems}
              isMapping={false}
              showModalExample={false}
              setShowModalExample={() => {}}
              hideSearchItemsList
            />
            <div className="col-12 md:col-6 text-right px-0">
              <div className="row justify-start md:justify-end items-center">
                <SharedButton
                  variant="secondary"
                  arrow={chartsSelect ? 'up' : 'down'}
                  onClick={() => setChartsSelect(!chartsSelect)}
                >
                  Select Graph: {selectedChart}
                </SharedButton>
                {/* Dropdown */}
                {chartsSelect && (
                  <div className="absolute z-10 mt-8 w-40 rounded-md shadow-lg bg-white border">
                    <ul className="py-1 text-sm text-gray-700">
                      {getAvailableCharts(names, sectionTitle, title).map((item, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 hover:bg-blue cursor-pointer hover:text-white"
                          onClick={() => handleDropdownClick(item)}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {Graph && (
        <Graph
          source={source}
          tab={tab}
          keySearch={keySearch}
          view={view}
          names={names}
          selectedChart={selectedChart}
          setSearchItems={setSearchItems}
        />
      )}
    </Fragment>
  );
}

export default ManageGraphs;
